// extracted by mini-css-extract-plugin
module.exports = {"pricingContainer":"Pricing_pricingContainer__Yu1qB","oldPrice":"Pricing_oldPrice__KK_xZ","range":"Pricing_range__dB9OM","link":"Pricing_link__y2d95"};